/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
// import { Redirect } from 'react-router-dom'

/**
 *     Import
 *     - Components
 */
import Container from '../../../../common/Container/Container'
import HeaderContainer from '../../../../common/HeaderContainer/HeaderContainer'
import Loading from '../../../../common/Loading/Loading'
import { Button } from '../../../../common/Button/Button'
import PopUp from '../../../../common/PopUp/PopUp'
import { get } from 'lodash'

/**
 *     Import
 *     - CSS
 */
import '../styles/mta.css'

export default class MTAConfirm extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            confirmBind: false,
            disableBind: false,
            boundPopUp: false,
        }
    }

    componentWillMount() {
        this.props.removePolicySubmit()
        this.props.getMTAPreview(this.props.match.params.id, this.props.match.params.mtaid)
    }

    componentWillUnmount() {
        this.props.mta.done = false
    }

    handleCancel = () => {
        this.props.history.push('/clients/policies')
    }

    okConfirmBind = () => {
        this.props.bindMTA(this.props.match.params.id, this.props.match.params.mtaid)
        this.setState({ confirmBind: false })
    }

    cancelConfirmBind = () => this.setState({ confirmBind: false })

    getSumInsuredTitle = () => {
        const { mta } = this.props
        if (get(mta, 'response.isCollectors', false)) {
            return 'New total collection sum insured'
        } else if (get(mta, 'response.isDealersStock', false)) {
            return 'New total dealers stock sum insured'
        } else if (get(mta, 'response.isMuseums', false)) {
            return 'New total Exhibits sum insured'
        } else if (get(mta, 'response.isWineSpirits', false)) {
            return 'New total Collection sum insured'
        } else if (get(mta, 'response.isCommercialProperty', false)) {
            return 'New total delcared value'
        } else {
            return 'New stock total sum insured'
        }
    }

    render() {

        const {
            isCollectors,
            isDealersStock,
            isMuseums,
            isWineSpirits,
            isCommercialProperty,
            mta_bound_data: { loading = false, error = false, success = false },
            mtaBound = false,
            mta,
        } = this.props
        // After bind redirect to Policies list
        // if (this.props.mtaBound) {
        //     return (<Redirect to={`/clients/policies`} />)
        // }

        // After fecth, if there's referrals, hide buttons
        if (!this.props.mta.loading
            && this.props.mta.done
            && this.props.mta.response.referrals.length !== 0
            && !this.state.disableBind) {
            this.setState({ disableBind: true })
        }
        let preTitles =
            isCollectors ? 'Collections Insurance' : isMuseums ? 'Museums Insurance' :
                isDealersStock ? 'Dealers Stock Insurance' :
                    isWineSpirits ? 'Wine & Spirits' : isCommercialProperty ?
                        get(mta, 'response.policyName', 'Property Owners') : 'Commercial Art Insurance'

        return (
            <div className="mta">
                <HeaderContainer
                    className="mta__header"
                    fullwidth={false}
                    pretitle={preTitles}
                    titles={['Confirm Mid Term Adjustment']}
                />

                <Container className="quote__edit mta__confirm" fullwidth={false}>

                    {
                        loading ?
                            <PopUp
                                title="MTA Bound Loading"
                                action={() => { '' }}
                            >
                                ...loading
                            </PopUp> : null
                    }
                    {this.state.confirmBind && !loading ? (
                        < PopUp
                            title="Confirm"
                            buttonText="Yes"
                            action={this.okConfirmBind}
                            numberButtons={2}
                            secondaryButtonText="No"
                            secondaryAction={this.cancelConfirmBind}
                        >
                            Are you sure?
                        </ PopUp>
                    ) : null}

                    {mtaBound && !loading ? (
                        < PopUp
                            title="MTA Bound"
                            buttonText="Back to policies list"
                            action={this.handleCancel}
                        >
                            The MTA has been bound
                        </ PopUp>
                    ) : null}

                    {error && !success && !loading ? (
                        < PopUp
                            title="MTA Bound Error"
                            buttonText="Back to policies list"
                            action={this.handleCancel}
                        >
                            {error}
                        </ PopUp>
                    ) : null}

                    {!this.props.mta.loading
                        && this.props.mta.done
                        && this.props.mta.response.referrals.length === 0 ? (
                        <PreviewMTA
                            data={this.props.mta.response}
                            preTitles={preTitles}
                            sumInsured={this.getSumInsuredTitle()}
                        />
                    ) : !this.props.mta.loading
                        && this.props.mta.done
                        && this.props.mta.response.referrals.length !== 0 ? (
                        <ReferralsMTA
                            data={this.props.mta.response.referrals}
                        />
                    ) : (
                        <Loading />
                    )}

                    {!this.state.disableBind ? (
                        <div className="mta__actions">
                            <Button
                                className="mta__actions__button"
                                onClick={this.handleCancel}
                            >
                                Back to policies list
                            </Button>
                            <Button
                                className="mta__actions__button mta__actions__button--confirm"
                                disabled={this.props.mta.response.statusMessage === 'in referral'}
                                onClick={() => this.setState({ confirmBind: true })}
                            >
                                Bind MTA
                            </Button>
                        </div>
                    ) : (
                        <div className="mta__actions mta__actions--referrals">
                            <Button
                                className="mta__actions__button"
                                onClick={this.handleCancel}
                            >
                                Back to policies list
                            </Button>
                        </div>
                    )}
                </Container>

            </div>
        )
    }
}

const numberWithCommas = (x) => {
    var parts = x.toString().split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return parts.join('.')
}

const PreviewMTA = ({ data, preTitles, sumInsured }) => (
    <div className="mta__confirm__container">

        <div className="mta__confirm__header">
            <div className="mta__confirm__title">
                {data.clientName}
            </div>
            <div className="mta__confirm__subtitle">
                {preTitles}
            </div>
            <div className="mta__confirm__code">
                {data.title}
            </div>
        </div>

        <div className="mta__confirm__row">

            <div className="mta__confirm__col">
                <div className="mta__confirm__col__title">
                    {sumInsured}
                </div>
                <div className="mta__confirm__col__info">
                    £{numberWithCommas(data.totalSumInsured)}
                </div>
            </div>

            <div className="mta__confirm__col">
                <div className="mta__confirm__col__title">
                    Effective date
                </div>
                <div className="mta__confirm__col__info">
                    {data.effectiveDate}
                </div>
            </div>

            <div className="mta__confirm__col">
                <div className="mta__confirm__col__title">
                    Expiry date
                </div>
                <div className="mta__confirm__col__info">
                    {data.expiryDate}
                </div>
            </div>

        </div>

        <div className="mta__confirm__row">

            <div className="mta__confirm__col">
                <div className="mta__confirm__col__title">
                    Original annual premium
                </div>
                <div className="mta__confirm__col__info">
                    £{numberWithCommas(data.originalPrice)} <span>inc.IPT</span>
                </div>
            </div>
            {/* {data.policyFee && (
                <div className="mta__confirm__col">
                    <div className="mta__confirm__col__title">
                        Policy fee
                    </div>
                    <div className="mta__confirm__col__info">
                        £{numberWithCommas(data.policyFee)}
                    </div>
                </div>)} */}

            <div className="mta__confirm__col">
                <div className="mta__confirm__col__title">
                    New annual premium
                </div>
                <div className="mta__confirm__col__info">
                    £{numberWithCommas(data.newPrice)} <span>inc.IPT</span>
                </div>
            </div>

        </div>

        <div className="mta__confirm__row">

            <div className="mta__confirm__col">
                <div className="mta__confirm__col__title">
                    Pro rata additional (or)<br />
                    return premium
                </div>
            </div>

            <div className="mta__confirm__col">
                <div className="mta__confirm__col__info mta__confirm__col__info--big">
                    £{numberWithCommas(data.premium)}
                </div>
            </div>

        </div>
    </div>
)

const ReferralsMTA = ({ data }) => {
    return (
        <div className="mta__confirm__container">

            <div className="mta__confirm__header">
                <div className="mta__confirm__title">
                    Referrals
                </div>
                <div className="mta__confirm__subtitle">
                    You have some referrals so you can't bind this!
                </div>
            </div>

            <div className="mta__confirm__row">

                <div className="mta__confirm__col mta__confirm__col--100">
                    {data.map((item, i) => (
                        item[''] ? (
                            item[''].map((nestedItem, j) => (
                                <div key={`${i}-${j}`} className="mta__confirm__col__title">
                                    <span>{nestedItem.title}:</span> {nestedItem.description}
                                </div>
                            ))
                        ) : (
                            <div key={i} className="mta__confirm__col__title">
                                <span>{item.title}:</span> {item.description}
                            </div>
                        )
                    ))}
                </div>

            </div>

        </div>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/components/MTAConfirm.tsx